import React, { useState, Fragment } from 'react';
import Auth from '../../amplify';
import {
  Button,
  Text,
  TextInput,
  Modal,
  Flex,
  Loader,
} from '../../components/common';
import styles from './styles.scss';

const VIEW_STATES = {
  request: 'request',
  loading: 'loading',
  confirm: 'confirm',
  success: 'success',
};
export default function ResetPasswordModal({ isVisible, onClose, onSuccess }) {
  const [view, setView] = useState(VIEW_STATES.request);
  const [error, setError] = useState('');

  const [form, setForm] = useState({
    verificationCode: '',
    email: '',
    newPassword: '',
    confirmPassword: ''
  });

  const updateForm = (key) => (value) => {
    if (key === 'newPassword' && value.target.value.length < 8) {
      setError('Password must be at least 8 characters long.');
    } else if (key === 'confirmPassword' && form.newPassword !== value.target.value) {
      setError('Password & Confirm Password do not match.');
    } else {
      setError('');
    }

    setForm({
      ...form,
      [key]: value && value.target ? value.target.value : value,
    });
  };

  const catchError = (originalView) => (err) => {
    if (err.message.indexOf('not found') > -1) {
      setError('No user account associated with this email address');
    } else {
      setError(err.message);
    }
    setView(originalView);
  };
  const submitForm = () => {
    setView(VIEW_STATES.loading);
    setError('');
    if (view === VIEW_STATES.request) {
      Auth.forgotPassword(form.email.trim().toLowerCase())
        .then(() => setView(VIEW_STATES.confirm))
        .catch(catchError(VIEW_STATES.request));
    } else if (view === VIEW_STATES.confirm) {
      Auth.forgotPasswordSubmit(
        form.email.trim().toLowerCase(),
        form.verificationCode,
        form.newPassword,
      )
        .then(() => setView(VIEW_STATES.success))
        .catch(catchError(VIEW_STATES.confirm));
    } else if (view === VIEW_STATES.success) {
      onClose();
    }
  };

  let body = <Loader />;
  let submitText = 'Send Verification Code';
  let isValid = form.email;
  if (view === VIEW_STATES.request) {
    body = (
      <Fragment>
        <Text bold size={14} mb={4}>
          Email Address to send verification code to
        </Text>
        <TextInput
          value={form.email}
          onChange={updateForm('email')}
          placeholder="Email Address"
          className={styles.resetInput}
        />
      </Fragment>
    );
  } else if (view === VIEW_STATES.confirm) {
    submitText = 'Submit New Password';
    isValid =
      form.verificationCode &&
      form.newPassword &&
      form.confirmPassword === form.newPassword &&
      form.newPassword.length > 7;
    body = (
      <Fragment>
        <Text bold size={14} styles={{ textAlign: 'center' }}>
          A verification code has been sent to {form.email}
        </Text>
        <Text bold size={14} mt={20} mb={4}>
          Verification Code
        </Text>
        <TextInput
          value={form.verificationCode}
          onChange={updateForm('verificationCode')}
          placeholder="Verification Code"
          className={styles.resetInput}
        />
        <Text bold size={14} mt={10} mb={4}>
          New Password
        </Text>
        <TextInput
          type="password"
          value={form.newPassword}
          onChange={updateForm('newPassword')}
          placeholder="New Password"
          className={styles.resetInput}
        />
        <Text bold size={14} mt={10} mb={4}>
          Confirm Password
        </Text>
        <TextInput
          type="password"
          value={form.confirmPassword}
          onChange={updateForm('confirmPassword')}
          placeholder="Confirm Password"
          className={styles.resetInput}
        />
      </Fragment>
    );
  } else if (view === VIEW_STATES.success) {
    submitText = 'Back to Login';
    body = (
      <Fragment>
        <Text secondary mt={20} mb={20}>
          Success!
        </Text>
        <Text size={14}>You may now login with your new password.</Text>
      </Fragment>
    );
  }
  return (
    <Modal medium isVisible={isVisible} onClose={onClose}>
      <Flex
        flex={1}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Text bold mb={30} thin size={24}>
          Reset Password
        </Text>
        {body}
        {error && (
          <Text isError size={14} mt={10} mb={10}>
            {error}
          </Text>
        )}
      </Flex>
      <Flex justifyContent="center" alignItems="center">
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button
          submit
          disabled={view === VIEW_STATES.loading || !isValid}
          onClick={submitForm}
        >
          {submitText}
        </Button>
      </Flex>
    </Modal>
  );
}
